<template>
  <b-card class="mobile-card" header-bg-variant="light">
    <b-container>
      <b-row align-v="center">
        <b-col>
          <strong>Date de valeur</strong>
          <br />
          {{ item.dateValeur }}
        </b-col>
        <b-col cols="auto">
          <DownloadComponent
            :typeDocument="typeDocument"
            :targetId="item.idFichier"
          ></DownloadComponent>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import DownloadComponent from "../controls/DownloadComponent.vue";
export default {
  name: "RecapitulatifCapsocCard",
  components: { DownloadComponent },
  props: ["item"],
  data() {
    return {
      typeDocument: this.$store.state.expl.typesDocument.RECAP_CAPSOC,
    };
  },
};
</script>
